import instance from "./index";

const normalizeId = (value) => {
  if (value === undefined || value === null || value === "") return null;

  const id = Number(value);
  return Number.isFinite(id) ? id : null;
};

const normalizeClientRole = (role) => ({
  ...role,
  roleId:
    role?.roleId ??
    role?.RoleId ??
    role?.clientRolesId ??
    role?.ClientRolesId ??
    role?.clientsRoleId ??
    role?.ClientsRoleId ??
    role?.clientRoleId ??
    role?.ClientRoleId ??
    role?.id ??
    role?.Id ??
    null,
  roleName: role?.roleName ?? role?.RoleName ?? role?.name ?? "",
  level: role?.level ?? role?.Level ?? null,
  clientId:
    role?.clientId ??
    role?.ClientId ??
    role?.client_id ??
    role?.client?.clientId ??
    role?.client?.ClientId ??
    null,
  clientName:
    role?.clientName ??
    role?.Client_Name ??
    role?.client?.clientName ??
    role?.client?.Client_Name ??
    role?.client?.name ??
    "",
  isDefault: Boolean(
    role?.isDefault ??
      role?.IsDefault ??
      role?.default ??
      role?.Default ??
      false,
  ),
  displayTrue: Boolean(role?.displayTrue ?? role?.DisplayTrue ?? false),
});

export const getAllClientRoles = async () => {
  try {
    const response = await instance.get("/clientsRoles/getAll");
    const data = response?.data;
    const list = Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
        ? data.data
        : [];

    return list.map(normalizeClientRole);
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to load client roles";
    throw new Error(message);
  }
};

export const getClientRoleById = async (roleId) => {
  if (roleId === undefined || roleId === null || roleId === "") {
    throw new Error("Role id is required");
  }

  try {
    const response = await instance.get(`/clientsRoles/getById/${roleId}`);
    const data = response?.data?.data ?? response?.data;
    return normalizeClientRole(data);
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to load client role";
    throw new Error(message);
  }
};

export const updateClientRole = async ({ roleId, roleName, level = 1 }) => {
  const trimmedName = String(roleName ?? "").trim();

  if (roleId === undefined || roleId === null || roleId === "") {
    throw new Error("Role id is required");
  }

  if (!trimmedName) {
    throw new Error("Role name is required");
  }

  try {
    const response = await instance.put(
      `/clientsRoles/updateClientsRoles/${roleId}`,
      {
        roleName: trimmedName,
        level,
      },
    );
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to update client role";
    throw new Error(message);
  }
};

export const createClientRole = async ({
  roleName,
  level = 1,
  clientId,
  isDefault = false,
}) => {
  const trimmedName = String(roleName ?? "").trim();
  const normalizedClientId = normalizeId(clientId);

  if (!trimmedName) {
    throw new Error("Role name is required");
  }

  if (!Number.isFinite(normalizedClientId)) {
    throw new Error("Client is required");
  }

  try {
    const response = await instance.post("/clientsRoles", {
      roleName: trimmedName,
      level,
      clientId: normalizedClientId,
      isDefault: Boolean(isDefault),
    });
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to create client role";
    throw new Error(message);
  }
};
